export enum LinkVariant {
	Default = "Default",
	Underline = "Underline",
}

export function getLinkClass(variant: LinkVariant): string {
	switch (variant) {
		case LinkVariant.Default:
			return "link";
		case LinkVariant.Underline:
			return "link text-underline";
	}
}
